import { useMemo } from "react";
import { Link, useNavigate } from "@tanstack/react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, describeError } from "../lib/api";
import { SettingsIcon } from "../components/Icons";
import { BackBar, Spinner } from "../components/ui";
import { ProfileBody, useStampTap } from "../components/Profile";
import { chunkCards } from "../components/LibraryCard";
import { outsideHref } from "../lib/returnTo";

/** Your own library card, edited in place; the gear goes to Settings. */
export function MePage() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const me = useQuery({ queryKey: ["me"], queryFn: api.me });
  const card = useQuery({ queryKey: ["profile", "me"], queryFn: () => api.profile("me") });
  const { tap, node } = useStampTap({ name: card.data?.name ?? "" });
  // The "new card issued" moment: once, on the first visit after a card fills. Never looked before: just remember where we are.
  const cards = card.data ? chunkCards(card.data.stamps).length : 0;
  const seen = card.data?.own?.lastCardSeen;
  const fresh = useMemo(() => Boolean(card.data && seen !== null && seen !== undefined && cards > seen), [card.dataUpdatedAt]); // eslint-disable-line react-hooks/exhaustive-deps
  const remember = () => { void api.cardSeen(cards).then(() => qc.invalidateQueries({ queryKey: ["profile", "me"] })); };
  if (card.data && seen === null) remember();
  // Back leaves your card for wherever you were before it, never into Settings (which links back here).
  const back = () => void navigate({ href: outsideHref() });

  return (
    <main className="page me-page">
      <BackBar label="Back" onClick={back} right={<Link to="/me/settings" className="gear" aria-label="Settings"><SettingsIcon width={20} height={20} /></Link>} />
      {card.isPending || me.isPending ? <Spinner />
        : card.isError ? <p className="error">{describeError(card.error)}</p>
        : card.data && me.data && <ProfileBody card={card.data} me={me.data} onStamp={tap} fresh={fresh} onFreshDone={remember} />}
      {node}
    </main>
  );
}
